import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Payments stats DTO
 */
@CaslSubject(AppSubjectEnum.PAYMENT)
export class PaymentsStatsDto extends BaseStatsDto {}
